import { FC } from 'react';

import { Heading } from '@savgroup-front-common/core/atoms/Heading';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import {
  formatReverseMoneyToString,
  formatStripeReverseMoneyNumberAmount,
} from '@savgroup-front-common/core/formatters/intl';
import { SafeFormattedMessageWithId } from '@savgroup-front-common/core/formatters/SafeFormattedMessageWithId';

import { PlanDto, PricingType } from '../../ChoosePlan.types';

import messages from './messages';
import { $Price, $PriceLine } from './PlanPrice.styles';

interface PlanPriceProps {
  plan: PlanDto;
}

export const PlanPrice: FC<PlanPriceProps> = ({ plan }) => {
  switch (plan.pricingType) {
    case PricingType.Free:
      return (
        <Heading level={3} withoutMargin>
          <SafeFormattedMessageWithoutSpread message={messages.freePrice} />
        </Heading>
      );
    case PricingType.Custom:
      return (
        <Heading level={3} withoutMargin>
          <SafeFormattedMessageWithoutSpread message={messages.customPrice} />
        </Heading>
      );
    case PricingType.OnUsage:
      return (
        <$PriceLine>
          <SafeFormattedMessageWithoutSpread
            message={messages.onUsagePrice}
            values={{
              price: (
                <$Price>
                  {formatStripeReverseMoneyNumberAmount(
                    plan.usagePrice.perFile,
                  )}
                </$Price>
              ),
            }}
          />
        </$PriceLine>
      );
    case PricingType.Packaged:
      return (
        <$PriceLine>
          <SafeFormattedMessageWithoutSpread
            message={messages.packagedPrice}
            values={{
              price: (
                <$Price>
                  {formatReverseMoneyToString(plan.cyclePrice, {
                    shouldStripIfInteger: true,
                  })}
                </$Price>
              ),
              billingCycle: (
                <SafeFormattedMessageWithId
                  id={`pricing.billingCycle.${plan.billingCycle}`}
                />
              ),
            }}
          />
        </$PriceLine>
      );
    default:
      return null;
  }
};
